import api from '../api/axiosInstance';

export const cnisService = {
  getAll: () => api.get('/api/cnis-endpoint'),
};